<h3 [class]="styleClass">
  <div class="flex align-items-center gap-3">
    @if (icon) {
      <i class="text-primary" [class]="icon"></i>
    }
    {{ text }}
    <p-badge *ngIf="count" [value]="count"></p-badge>
    @if (suffix) {
      <code class="ml-3 flex gap-2 align-items-center font-bold text-lg">
        @if (suffixIcon) {
          <i [class]="suffixIcon"></i>
        }

        {{ suffix }}
      </code>
    }
    @if (help) {
      <div
        class="cursor-help text-xs text-color-secondary font-light -mt-2 -ml-2">
        <i class="fas fa-question-circle" [pTooltip]="help"></i>
      </div>
    }
  </div>
  @if (sub) {
    <div
      class="text-sm text-color-secondary font-light mt-2"
      [innerHTML]="sub"></div>
  }
</h3>
